import React from 'react'
import { useRef, useCallback, useState } from 'react'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import * as Yup from 'yup'
import { AiOutlineLock } from 'react-icons/ai'

import Input from '../../../../components/Input'
import { ILogin } from '../../../../types/login'
import LogoDirecao from '../../../../assets/logos/Direção_2023_Logo_Direção.svg'
import getValidationError from '../../../../utils/getValidationErrors'
import history from '../../../../services/history'
import { toast } from 'react-toastify'

import { Container, ResetWrapper, WrapperForm } from './styles'
import { RESET_PASSWORD } from 'pages/ResetPassword/services'

const ResetPasswordComponent: React.FC = () => {
  const formRef = useRef<FormHandles>()
  const [loading, setLoading] = useState(false)

  const handleSaveNewPassword = useCallback(async (data: ILogin) => {
    try {
      setLoading(true)
      formRef.current?.setErrors({})
      const urlParams = new URLSearchParams(window.location.search)

      const schema = Yup.object().shape({
        password: Yup.string().min(6, 'Senha deve conter pelo menos seis caracteres'),
        confirmPassword: Yup.string().oneOf(
          [Yup.ref('password'), null],
          'As senhas devem ser iguais'
        ),
      })

      await schema.validate(data, {
        abortEarly: false,
      })

      const response = await RESET_PASSWORD(
        data.password,
        urlParams.get('email'),
        urlParams.get('token')
      )
      setLoading(false)

      if (response.status === 401) return
      if (response?.status === 200) {
        toast.success('Senha alterada com sucesso!')
      } else {
        toast.error('Não foi possível alterar a senha, tente novamente mais tarde!')
      }

      history.push('/')
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationError(err)
        formRef.current?.setErrors(errors)
      }
    }
  }, [])

  return (
    <Container>
      <ResetWrapper>
        <WrapperForm>
          <img src={LogoDirecao} alt="Direção Concursos" />
          <Form ref={formRef} onSubmit={handleSaveNewPassword} autoComplete="false">
            <Input
              name="password"
              placeholder="Digite a nova senha"
              icon={AiOutlineLock}
              type="password"
            />
            <Input
              name="confirmPassword"
              placeholder="Digite a senha novamente"
              icon={AiOutlineLock}
              type="password"
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Aguarde...' : 'Trocar senha'}
            </button>
          </Form>
        </WrapperForm>
      </ResetWrapper>
    </Container>
  )
}

export default ResetPasswordComponent
